// Tooltip popup chọn quà nằm trong .list-boxs (khung cuộn) + .box-item (overflow:hidden) -> bị cắt.
// Khi hover: BÊ tooltip ra thẳng <body> rồi position:fixed.
// MẸO định vị: đặt left:0;top:0 và dời CHỖ bằng transform (translate theo viewport). Lý do:
//   - <body> không có ancestor transform -> containing-block của fixed là viewport -> không cần
//     trừ rect .MS__box (cách cũ trừ rect bị lệch do transform translateX của box).
//   - left:0 (không phải item.x) -> shrink-to-fit của box dùng full bề rộng viewport làm "available",
//     nên box tự co đúng theo nội dung (không bị bóp hẹp khi item ở sát mép phải). transform KHÔNG
//     ảnh hưởng tính bề rộng nên dời box thoải mái.
// Hiện/ẩn bằng class .is-show (CSS global .effect__tooltip), không dùng .item:hover vì tooltip
// lúc này đã không còn nằm trong .item.
$(document).on('mouseenter', '#popup_chonqua .list-items .item', function () {
	var tip = this._msTip || this.querySelector('.effect__tooltip');
	if (!tip) return;
	this._msTip = tip;
	var ir = this.getBoundingClientRect();
	if (tip.parentNode !== document.body) document.body.appendChild(tip);
	var cx = ir.left + ir.width / 2; // tâm ngang item
	var cy = ir.top;                 // mép trên item
	tip.style.position = 'fixed';
	tip.style.margin = '0';
	tip.style.left = '0';
	tip.style.top = '0';
	// PHẢI clear bottom/right (CSS resting có bottom:100%): nếu để cả top:0 + bottom:100%
	// thì fixed bị over-constrain -> chiều cao tính theo top/bottom (≈0) chứ không theo nội dung.
	tip.style.bottom = 'auto';
	tip.style.right = 'auto';
	// dời tới (cx, cy) rồi căn giữa ngang + bung lên trên item, chừa 14px
	tip.style.transform = 'translate(' + cx + 'px, ' + cy + 'px) translate(-50%, calc(-100% - 14px))';
	tip.classList.add('is-show');
});
$(document).on('mouseleave', '#popup_chonqua .list-items .item', function () {
	var tip = this._msTip;
	if (!tip) return;
	tip.classList.remove('is-show');
	tip.style.cssText = '';        // xoá hết inline style đã set khi hover
	this.appendChild(tip);         // trả tooltip về lại trong item
});
